import React from "react";
import PropertyDetailsPresenterGeneral from "./tabs/PropertyDetailsPresenterGeneral";
import ReservationSettingPresenterGeneral from "../ReservationSettingPresenter/tabs/ReservationSettingPresenterGeneral";
import PropertyDetailsPresenterLocks from "./tabs/PropertyDetailsPresenterLocks";
import PropertyDetailsPresenterHistory from "./tabs/PropertyDetailsPresenterHistory";

class PropertyDetailsPresenterTabContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.revert == true) {
      return (
        <div className="tab-content">
          <PropertyDetailsPresenterGeneral {...this.props} />
        </div>
      );
    } else {
      return (
        <div className="tab-content">
          <PropertyDetailsPresenterGeneral {...this.props} />
          {!this.props.superadmin ? (
            <ReservationSettingPresenterGeneral {...this.props} />
          ) : null}
          {!this.props.superadmin ? (
            <PropertyDetailsPresenterLocks {...this.props} />
          ) : null}
          <PropertyDetailsPresenterHistory {...this.props} />
        </div>
      );
    }
  }
}

export default PropertyDetailsPresenterTabContent;
